<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button useRelativePath="true" previousPageUrl="../../"></glxy-page-nav-button>
    </glxy-page-nav>
    @if (testSuite(); as suite) {
      <glxy-page-title>
        <span>{{ suite.name }}</span>
      </glxy-page-title>
      <glxy-page-actions>
        <button mat-button (click)="openEditSuiteModal()">
          <mat-icon>edit</mat-icon>
          {{ 'AI_ASSISTANT.TESTING.SUITE.EDIT' | translate }}
        </button>
        <button mat-button color="warn" (click)="deleteSuite()">
          <mat-icon>delete</mat-icon>
          {{ 'AI_ASSISTANT.SHARED.DELETE' | translate }}
        </button>
      </glxy-page-actions>
    } @else {
      <glxy-page-title>
        <span>{{ 'AI_ASSISTANT.TESTING.SUITE.TITLE' | translate }}</span>
      </glxy-page-title>
    }
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="wide">
    @if (testSuite(); as suite) {
      @if (suite.description) {
        <p class="suite-description">{{ suite.description }}</p>
      }
      @if (suite.tags && suite.tags.length > 0) {
        <mat-chip-set class="suite-tags">
          @for (tag of suite.tags; track $index) {
            <mat-chip>{{ tag }}</mat-chip>
          }
        </mat-chip-set>
      }
    }
    @if (isLoading()) {
      <div class="loading-container">
        <glxy-loading-spinner></glxy-loading-spinner>
      </div>
    } @else {
      <mat-card class="section-card">
        <mat-card-content>
          <div class="section-header">
            <h3>{{ 'AI_ASSISTANT.TESTING.TEST_TYPE.CHAT' | translate }} {{ 'AI_ASSISTANT.TESTING.SUITE.TEST_CASES' | translate }}</h3>
            <div class="header-actions">
              <button mat-stroked-button color="primary" (click)="openAddTestCasesModal('chat')">
                <mat-icon>add</mat-icon>
                {{ 'AI_ASSISTANT.TESTING.SUITE.ADD_TEST_CASES' | translate }}
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="runChatTests()"
                [disabled]="chatTestCases().length === 0"
              >
                <mat-icon>play_arrow</mat-icon>
                {{ 'AI_ASSISTANT.TESTING.SUITE.RUN_CHAT_TESTS' | translate }}
              </button>
            </div>
          </div>
          @if (chatTestCases().length === 0) {
            <div class="empty-state">
              <mat-icon>assignment</mat-icon>
              <p>{{ 'AI_ASSISTANT.TESTING.SUITE.NO_CASES' | translate }}</p>
              <p class="hint">{{ 'AI_ASSISTANT.TESTING.SUITE.NO_CASES_HINT' | translate }}</p>
            </div>
          } @else {
            @for (group of chatGroupedTestCases(); track group.key) {
              <div class="test-case-group">
                <a class="group-header group-header-link" [routerLink]="getAssistantTestRoute(group)">
                  <mat-icon>smart_toy</mat-icon>
                  <span class="assistant-name">{{ group.assistantName }}</span>
                  <span class="namespace-name">({{ group.namespaceName }})</span>
                  <mat-icon class="link-icon">open_in_new</mat-icon>
                </a>
                <mat-list>
                  @for (testCase of group.testCases; track testCase.id) {
                    <mat-list-item class="test-case-item">
                      <div class="test-case-content">
                        <span class="test-case-name">{{ testCase.name }}</span>
                        <button mat-icon-button [matMenuTriggerFor]="chatMenu" (click)="$event.stopPropagation()">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #chatMenu="matMenu">
                          <button mat-menu-item (click)="removeTestCase(testCase)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'AI_ASSISTANT.TESTING.SUITE.REMOVE_FROM_SUITE' | translate }}</span>
                          </button>
                        </mat-menu>
                      </div>
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            }
          }

          <mat-divider></mat-divider>

          <div class="section-header">
            <h3>{{ 'AI_ASSISTANT.TESTING.TEST_TYPE.VOICE' | translate }} {{ 'AI_ASSISTANT.TESTING.SUITE.TEST_CASES' | translate }}</h3>
            <div class="header-actions">
              <button mat-stroked-button color="primary" (click)="openAddTestCasesModal('voice')">
                <mat-icon>add</mat-icon>
                {{ 'AI_ASSISTANT.TESTING.SUITE.ADD_TEST_CASES' | translate }}
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="runVoiceTests()"
                [disabled]="voiceTestCases().length === 0"
              >
                <mat-icon>play_arrow</mat-icon>
                {{ 'AI_ASSISTANT.TESTING.SUITE.RUN_VOICE_TESTS' | translate }}
              </button>
            </div>
          </div>
          @if (voiceTestCases().length === 0) {
            <div class="empty-state">
              <mat-icon>assignment</mat-icon>
              <p>{{ 'AI_ASSISTANT.TESTING.SUITE.NO_CASES' | translate }}</p>
              <p class="hint">{{ 'AI_ASSISTANT.TESTING.SUITE.NO_CASES_HINT' | translate }}</p>
            </div>
          } @else {
            @for (group of voiceGroupedTestCases(); track group.key) {
              <div class="test-case-group">
                <a class="group-header group-header-link" [routerLink]="getAssistantTestRoute(group)">
                  <mat-icon>smart_toy</mat-icon>
                  <span class="assistant-name">{{ group.assistantName }}</span>
                  <span class="namespace-name">({{ group.namespaceName }})</span>
                  <mat-icon class="link-icon">open_in_new</mat-icon>
                </a>
                <mat-list>
                  @for (testCase of group.testCases; track testCase.id) {
                    <mat-list-item class="test-case-item">
                      <div class="test-case-content">
                        <span class="test-case-name">{{ testCase.name }}</span>
                        <button mat-icon-button [matMenuTriggerFor]="voiceMenu" (click)="$event.stopPropagation()">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #voiceMenu="matMenu">
                          <button mat-menu-item (click)="removeTestCase(testCase)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'AI_ASSISTANT.TESTING.SUITE.REMOVE_FROM_SUITE' | translate }}</span>
                          </button>
                        </mat-menu>
                      </div>
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            }
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="section-card">
        <mat-card-content>
          <div class="section-header">
            <h3>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TITLE' | translate }}</h3>
          </div>
          <form [formGroup]="scheduleForm" class="schedule-form">
            <glxy-form-field>
              <glxy-label>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_LABEL' | translate }}</glxy-label>
              <mat-select formControlName="tier">
                <mat-option [value]="ScheduleTier.SCHEDULE_TIER_NONE">
                  {{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_NONE' | translate }}
                </mat-option>
                <mat-option [value]="ScheduleTier.SCHEDULE_TIER_DAILY">
                  {{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_DAILY' | translate }}
                </mat-option>
                <mat-option [value]="ScheduleTier.SCHEDULE_TIER_WEEKLY">
                  {{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_WEEKLY' | translate }}
                </mat-option>
              </mat-select>
              @if (scheduleForm.controls.tier.value === ScheduleTier.SCHEDULE_TIER_NONE) {
                <glxy-hint>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_OFF_HINT' | translate }}</glxy-hint>
              } @else {
                <glxy-hint>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.TIER_HINT' | translate }}</glxy-hint>
              }
            </glxy-form-field>

            <glxy-form-field>
              <glxy-label>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.WEBHOOK_LABEL' | translate }}</glxy-label>
              <input
                matInput
                [type]="webhookVisible() ? 'text' : 'password'"
                autocomplete="off"
                formControlName="webhookUrl"
              />
              <glxy-suffix>
                <button
                  mat-icon-button
                  type="button"
                  (click)="webhookVisible.set(!webhookVisible())"
                  [attr.aria-label]="
                    (webhookVisible()
                      ? 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.HIDE_WEBHOOK'
                      : 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.SHOW_WEBHOOK'
                    ) | translate
                  "
                >
                  <mat-icon>{{ webhookVisible() ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </glxy-suffix>
              <glxy-hint>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.WEBHOOK_HINT' | translate }}</glxy-hint>
              @if (scheduleForm.controls.webhookUrl.hasError('maxlength')) {
                <glxy-error>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.WEBHOOK_TOO_LONG' | translate }}</glxy-error>
              } @else if (scheduleForm.controls.webhookUrl.hasError('gchatWebhook')) {
                <glxy-error>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.WEBHOOK_INVALID' | translate }}</glxy-error>
              }
            </glxy-form-field>

            <div class="threshold-fields">
              @for (field of thresholdFields; track field.control) {
                <glxy-form-field>
                  <glxy-label>{{ field.labelKey | translate }}</glxy-label>
                  <input matInput type="number" min="0" max="100" [formControlName]="field.control" />
                  <glxy-hint>{{ field.hintKey | translate }}</glxy-hint>
                  @if (scheduleForm.get(field.control)?.invalid) {
                    <glxy-error>{{ 'AI_ASSISTANT.TESTING.SCHEDULE_CARD.THRESHOLD_RANGE_ERROR' | translate }}</glxy-error>
                  }
                </glxy-form-field>
              }
            </div>

            <div class="schedule-actions">
              <button
                mat-raised-button
                color="primary"
                [disabled]="isSavingSchedule() || scheduleForm.invalid"
                (click)="saveSchedule()"
              >
                <glxy-button-loading-indicator [isLoading]="isSavingSchedule()">
                  {{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}
                </glxy-button-loading-indicator>
              </button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      @if (testRunLoading()) {
        <div class="loading-container">
          <glxy-loading-spinner size="small"></glxy-loading-spinner>
        </div>
      }

      @if (testSuiteId) {
        <ai-test-run-table
          [testSuiteId]="testSuiteId"
          [showSuccessEvalFilters]="false"
          #testRunTable
        ></ai-test-run-table>
      }
    }
  </glxy-page-wrapper>
</glxy-page>
